import { ACCURACY } from "@/data/content";

// Configurable proof component — rendered only when ACCURACY.enabled is true.
const AccuracyProof = ({ dark = true }) => {
  if (!ACCURACY.enabled) return null;
  return (
    <div
      data-testid="accuracy-proof"
      className={`rounded-sm border p-8 lg:p-10 ${dark ? "border-coalline bg-coalsurf" : "border-line bg-white"}`}
    >
      <p className={dark ? "eyebrow-dark" : "eyebrow"}>Track record</p>
      <p className={`mt-6 text-5xl lg:text-6xl tracking-tight ${dark ? "text-ivory" : "text-ink"}`}>{ACCURACY.value}</p>
      <p className={`mt-2 text-sm ${dark ? "text-[#A0A09C]" : "text-dim"}`}>{ACCURACY.label}</p>
      <p className={`mt-6 pt-6 border-t text-xs leading-relaxed ${dark ? "border-coalline text-[#8E8E8B]" : "border-line text-tertiary"}`}>
        {ACCURACY.disclosure}
      </p>
    </div>
  );
};

export default AccuracyProof;
